import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import {
    AuthContextType,
    AuthContextTypeRequiredAuthenticatedUser,
} from '../types/auth-context.type';
import Page from '../../pages/logout/index.page';

/**
 * Use the `useAuth` hook in your components to access the auth state and methods.
 */
export const useAuth = (): AuthContextType => useContext(AuthContext);

export const useAuthWithRequiredAuthenticatedUser = (): AuthContextTypeRequiredAuthenticatedUser => {
    const auth = useContext(AuthContext);

    if (!auth.isAuthenticated || !auth.user) {
        Page();
    }
    return auth as AuthContextTypeRequiredAuthenticatedUser;
};

export default useAuth;
